import React, {useContext, useState} from 'react'
import { Modal, Row, Col, Input, Radio, Upload } from "antd";
import { PlusOutlined, CloseOutlined  } from '@ant-design/icons'
import { AppContext } from '../../util/context';

import ActionTakenDetailsInput from './ActionTakenDetailsInput';

const getBase64 = (file) =>
    new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = (error) => reject(error);
    }
);

const uploadButton = (
    <button
      style={{
        border: 0,
        background: 'none',
      }}
      type="button"
    >
      <PlusOutlined />
      <div
        style={{
          marginTop: 8,
        }}
      >
        Add
      </div>
    </button>
);

export const Action = ({setActionValidations, actionValidations, formState, setFormState, setModalDetails}) => {
    const {
        StyledDiv
    } = useContext(AppContext)
    
    const [currentAction, setCurrentAction] = useState("");
    const [actionDetailsValidation, setActionDetailsValidation] = useState("")

    const [previewOpen, setPreviewOpen] = useState(false);
    const [previewImage, setPreviewImage] = useState('');
    const [previewTitle, setPreviewTitle] = useState('');
    const [uploadError, setUploadError] = useState(false);


    const [maxChar, setMaxChar] = useState(currentAction.length);

    const handleAddAction = () => {
        if(currentAction === "") {
            setActionDetailsValidation("Action details is required");
        }else{
            let currentActions = [...formState.actions];
            currentActions = [
                ...currentActions,
                currentAction
            ];
            
            let newFormState = {
                ...formState,
                actions: currentActions
            }

            setFormState(newFormState);
            setCurrentAction('');
            setActionValidations(prevState => ({ ...prevState, actions: "" }));
            setMaxChar(0);
        }
    }
    
    const handleRemoveAction = (actionIndex) => {
        let currentActions = [...formState.actions];
        
        currentActions.splice(actionIndex, 1); 

        let newFormState = {
            ...formState,
            actions: currentActions
        }

        setFormState(newFormState);
    }

    function beforeUpload(file) {
        const allowedTypes = [
            'image/jpg',
            'image/jpeg',
            'image/png',
            'application/pdf',
            'application/msword',
            'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
            'application/vnd.ms-excel',
            'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
            'application/vnd.ms-powerpoint',
            'application/vnd.openxmlformats-officedocument.presentationml.presentation',

            'video/quicktime',
            'video/mp4',
        ];
        const maxSizeMB = 30;
        const maxSizeBytes = maxSizeMB * 1024 * 1024;
    
        if (!allowedTypes.includes(file.type)) {
            setUploadError(true)
            setModalDetails({show: true, loading: false, title: "Type Error", content: "Invalid File Type: " + file.type, error: true})
            console.log("Invalid File Type: " + file.type);
            return false;
        }
    
        if (file.size > maxSizeBytes) {
            setUploadError(true)
            setModalDetails({show: true, loading: false, title: "Size Error", content: "File is too large: " + (file.size / (1024 * 1024)).toFixed(2) + "MB. Maximum allowed size is " + maxSizeMB + "MB", error: true})
            console.log("File is too large: " + (file.size / (1024 * 1024)).toFixed(2) + "MB. Maximum allowed size is " + maxSizeMB + "MB");
            return false;
        }

        setUploadError(false)
        return true;
        
    }

    const handleCancel = () => setPreviewOpen(false);

    const handlePreview = async (file) => {
        if (!file.url && !file.preview) {
            file.preview = await getBase64(file.originFileObj);
        }
        setPreviewImage(file.url || file.preview);
        setPreviewOpen(true);
        setPreviewTitle(file.name || file.url.substring(file.url.lastIndexOf('/') + 1));
    };

    const setFiles = newFiles => {
        setFormState(prevState => ({
            ...prevState,
            files: newFiles
        }));
    };

    const setLocalFiles = newFiles => {      
        setFormState(prevState => ({
            ...prevState,
            localFiles: newFiles
        }));
    };

    const handleChange = async(info) => {
        if(!uploadError){
            const {fileList} = info;
            setLocalFiles(fileList);
        }
    };

    const customRequest = ({file, onSuccess}) => {  
        if(!uploadError){
            const currentFiles = [...formState.files];
            currentFiles.push(file);
            setFiles(currentFiles);
        
            const dummyResponse = { status: 'success', url: 'http://example.com/' + file.name };
            onSuccess(dummyResponse, file);
        }
    }
    
    const handleRemove = (file) => {
        const newFiles = formState.files.filter(f => f.uid !== file.uid);
        setFiles(newFiles);
    };

    return (
        <>
            <Modal open={previewOpen} title={previewTitle} footer={null} onCancel={handleCancel}>
                <img
                alt="example"
                style={{
                    width: '100%',
                }}
                    src={previewImage}
                />
            </Modal>
            
            <Row
                className='InputContainer'
            >
                <Col
                    span={24}
                >
                    <StyledDiv className="newInputTextLabel"><label><span style={{color: "red"}}>*</span> Immediate Action Taken {actionValidations.immediateActionTaken !== "" && <StyledDiv style={{color:"red", fontSize: "10px"}}>{actionValidations.immediateActionTaken}</StyledDiv>}</label></StyledDiv>
                    <Radio.Group 
                        disabled = {false}
                        value={formState.immediateActionTaken}
                        onChange={(e) => {
                            setFormState(prevState => ({ ...prevState, immediateActionTaken: e.target.value }));
                            if(actionValidations.immediateActionTaken !== "")
                                setActionValidations(prevState => ({ ...prevState, immediateActionTaken: "" }))
                        }}
                        style={{
                            marginTop: "10px"
                        }}
                    >
                        
                        <StyledDiv>
                            <Radio value="yes" className="newInputText">Yes</Radio>
                            <Radio value="no" className="newInputText">No</Radio>
                        </StyledDiv>
                    </Radio.Group>
                </Col>
            </Row>

            {formState.immediateActionTaken === 'yes' && <Row
                className='InputContainer'
                style={{
                    marginBottom: "40px"
                }}
            >
                <Col
                    span={24}
                >
                    <label>     
                        <StyledDiv className="newInputTextLabel">
                            <ActionTakenDetailsInput
                                formState={formState}
                                setFormState={setFormState}
                                actionValidations={actionValidations}
                                setActionValidations={setActionValidations}
                            />
                        </StyledDiv>
                    </label>
                </Col>
            </Row>}

            <Row
                className='InputContainer'
            >
                <Col
                    span={24}
                >
                    <StyledDiv className="newInputTextLabel"><label><span style={{color: "red"}}>*</span> Further Action Required {actionValidations.furtherActionRequired !== "" && <StyledDiv style={{color:"red", fontSize: "10px"}}>{actionValidations.furtherActionRequired}</StyledDiv>}</label></StyledDiv>
                    <Radio.Group 
                        value={formState.furtherActionRequired}
                        onChange={(e) => {
                            setFormState(prevState => ({ ...prevState, furtherActionRequired: e.target.value }));
                            if(actionValidations.furtherActionRequired !== "")
                                setActionValidations(prevState => ({ ...prevState, furtherActionRequired: "" }))
                        }}
                        style={{
                            marginTop: "10px"
                        }}
                    >
                        
                        <StyledDiv>
                            <Radio value="yes" className="newInputText">Yes</Radio>
                            <Radio value="no" className="newInputText">No</Radio>
                        </StyledDiv>
                    </Radio.Group>
                </Col>
            </Row>

            {formState.furtherActionRequired === "yes" && <>
                <Row
                    className='InputContainer'
                    style={{
                        marginTop: "40px",
                        marginBottom: "10px"
                    }}
                >
                    <Col
                        span={24}
                    >
                        <StyledDiv className="newInputTextLabel"><label>State Actions</label></StyledDiv>

                    </Col>  

                </Row>


                <Row
                    className='InputContainer'
                    style={{
                        marginBottom: "20px"
                    }}
                >
                    <Col
                        span={24}
                    >
                        {actionValidations.actions !== "" && <StyledDiv style={{color:"red", fontSize: "10px", fontWeight: "600", marginBottom: "5px"}}>*{actionValidations.actions}</StyledDiv>}
                        <StyledDiv className="actionHelperText"><label>
                        Enter the action details in the input box below and select the <span style={{color: "rgb(174,32,114)", fontSize: "20px"}}>+</span> icon to add the action to the list. Selecting the <span style={{color: "red", fontSize: "14px"}}>X</span> will remove the action from the list    
                        </label></StyledDiv>
                    </Col>  

                </Row>

                <Row
                    className='InputContainer'
                    style={{
                        marginBottom: "40px"
                    }}
                >
                    <Col
                        span={20}
                    >
                        <StyledDiv>
                            <div className="generalInfoContainer">
                                <Input.TextArea placeholder="Enter action (max length 300 characters)" 
                                    onChange={(e) => {
                                        setCurrentAction(e.target.value);
                                        setMaxChar(e.target.value.length);
                                        if(actionDetailsValidation !== "") 
                                            setActionDetailsValidation("");
                                    }}
                                    style={{
                                        resize: "none",
                                        height: "100px",
                                        marginTop: "8px",
                                    }}
                                    maxLength={300}
                                    value = {currentAction}
                                    className={actionDetailsValidation !== "" ? "newActionInput validationInputText" : "newActionInput"}
                                />
                                {actionDetailsValidation !== "" &&
                                    <span className="validationMessage">{actionDetailsValidation}</span>
                                }
                                
                                <span className="maxCharMessage">{maxChar}/300</span>
                                
                            </div>
                        </StyledDiv>
                    </Col>  

                    <Col
                        span={4}
                        style={{
                            display: "flex",
                            justifyContent: "center"
                        }}
                    >

                        <PlusOutlined 
                            className="helpIcon"
                            onClick = {() => handleAddAction()}
                        />
                        
                    </Col> 

                </Row>
                <div
                    className="actionsContainer"
                >
                {formState.actions && formState.actions.map((action, index) => {
                    return (
                        <Row className='newActionListContainer' key={index}>
                            <Col span={20} className="actionListText">
                                <StyledDiv ><label>{action}</label></StyledDiv>
                            </Col>
                            <Col span={4}
                                style={{
                                    display: "flex",
                                    justifyContent: "end",
                                    paddingRight: "10px"
                                }}
                            >
                                <CloseOutlined onClick = {() => handleRemoveAction(index)} className="removeActionIcon"/>
                            </Col>
                        </Row>
                    )
                })}
                </div>
            </>}

            {/* Uploads */}
            <Row
                className='SubInputContainer'
                style={{
                    marginTop: "60px"
                }}
            >
                <StyledDiv className="newInputTextLabel"><label style={{marginBottom: "10px", width: "100%", textAlign: "center"}}>Uploads & Attachments</label></StyledDiv>
                
            </Row>

            <Row
                className='SubInputContainer'
                style={{
                    marginBottom: "40px"
                }}
            >
                <Upload
                    listType="picture-card"
                    fileList={formState.localFiles.length > 0 ? formState.localFiles : []}
                    onPreview={handlePreview}
                    onChange={handleChange}
                    customRequest={customRequest}
                    onRemove={handleRemove}
                    beforeUpload={beforeUpload}
                >
                    {formState.localFiles.length >= 8 ? null : uploadButton}
                </Upload>
                
            </Row>
        </>
    )
}
